<template>
  <router-view />
</template>

<script>
export default {
  name: 'FlightsReservationsIndex'
}
</script>
